import {Button, Card, Flex, Typography} from 'antd';
import {BackButtonWText} from 'Components';
import {gqlSetMemberGift} from 'GQL/MethodsBFF/Gifting';
import parse from 'html-react-parser';
import React, {Fragment, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isUpdateSRList} from 'Redux/Slices/SRListFilter';
import {GIFTING} from '../giftingConstants';
import GiftDialog from './dialogs/GiftDialog';
import GiftDialogError from './dialogs/GiftDialogError';
import GiftDialogSuccess from './dialogs/GiftDialogSuccess';

interface IProps {
  toggleView?: any;
  selectedGiftOffer: any;
}

const GiftDetailView: React.FC<IProps> = (props) => {
  const {toggleView, selectedGiftOffer} = props;
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const currentMemberDetails = selectedMember.currentMemberDetails;
  const {externalRefId, memberId, clientEmail} = useSelector(
    (state: any) => state?.selectedMember?.selectedMember?.focusedMemberDetails,
  );
  let dispatch = useDispatch();

  const [openGiftingDialog, setOpenGiftingDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [manualEmailEntry, setManualEmailEntry] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmitGift = async () => {
    setLoading(true);
    const {data, error} = await gqlSetMemberGift({
      GiftingOfferRequestInput: {
        firstName: currentMemberDetails?.firstName,
        emailId: clientEmail || manualEmailEntry,
        offerId: selectedGiftOffer.id,
        merchantName: selectedGiftOffer.merchant?.name,
        titleShort: selectedGiftOffer.titleShort,
        memberId: memberId,
        memberExternalRefId: externalRefId,
      },
    });
    setLoading(false);
    if (data?.giftToCustomer) {
      setOpenGiftingDialog(false);
      setOpenSuccessDialog(true);
      dispatch(
        isUpdateSRList({
          isRefreshSRList: true,
        }),
      );
    } else if (error) {
      if (error.message.includes('MO1013')) {
        setOpenGiftingDialog(false);
        setOpenErrorDialog(true);
        setErrorMessage('MO1013');
      }
      if (error.message.includes('MO1007')) {
        setOpenGiftingDialog(false);
        setOpenErrorDialog(true);
        setErrorMessage('MO1007');
      }
    }
  };

  return (
    <Fragment>
      <Flex>
        <BackButtonWText text={GIFTING.detail_view.back_button_text} callback={toggleView} />
      </Flex>
      <div>
        <Card
          styles={{body: {padding: 0}}}
          cover={
            <img
              src={selectedGiftOffer.images[2].imageUrl}
              alt={selectedGiftOffer.images[2].altText}
              style={{height: 200, objectFit: 'cover'}}
            />
          }>
          <div style={{padding: 32}}>
            <Typography.Text style={{display: 'block', textAlign: 'center'}}>
              {selectedGiftOffer.titleShort}
            </Typography.Text>
            <Typography.Text>{parse(selectedGiftOffer.description)} </Typography.Text>
            <Flex justify="space-between" align="center" style={{marginTop: 48}}>
              <img src={selectedGiftOffer.images[0].imageUrl} alt="" height="40" width="40" />
              <Button
                type="primary"
                onClick={() => setOpenGiftingDialog(true)}
                style={{width: '25%'}}>
                {GIFTING.detail_view.button_text}
              </Button>
              &nbsp;
            </Flex>
          </div>
        </Card>
        <div style={{margin: '48px 32px'}}>
          <Typography.Text strong>{GIFTING.detail_view.heading1}</Typography.Text>
          <Typography.Text style={{display: 'block'}}>
            {parse(selectedGiftOffer.keyTerms) || ''}
          </Typography.Text>
          <Typography.Text strong style={{display: 'block', marginTop: 32}}>
            {GIFTING.detail_view.heading2}
          </Typography.Text>
          <Typography.Text style={{display: 'block'}}>
            {parse(selectedGiftOffer.termsAndConditions)}
          </Typography.Text>
        </div>
        <GiftDialog
          openGiftingDialog={openGiftingDialog}
          setOpenGiftingDialog={setOpenGiftingDialog}
          handleSubmitGift={handleSubmitGift}
          customerEmail={clientEmail}
          manualEmailEntry={manualEmailEntry}
          setManualEmailEntry={setManualEmailEntry}
          loading={loading}
        />
        <GiftDialogSuccess
          customerEmail={clientEmail || manualEmailEntry}
          openSuccessDialog={openSuccessDialog}
          setOpenSuccessDialog={setOpenSuccessDialog}
        />
        <GiftDialogError
          openErrorDialog={openErrorDialog}
          setOpenErrorDialog={setOpenErrorDialog}
          errorMessage={errorMessage}
        />
      </div>
    </Fragment>
  );
};

export default GiftDetailView;
